import Vue from 'vue';

import { initialize } from '../../../util/sentry';
initialize(Vue);

import suggestedProductsComponent from '../../../components/shop/details/expremanental/suggestedProducts.vue';

new Vue({
  el: '#vue-suggested-products-section',
  components: {
    'vue-suggested-products': suggestedProductsComponent
  }
});
